import qs from 'qs'
import { HTTP } from './helpers/http.js'

export default {
  getReport(organizationId, query) {

    const url = `/api/v2/organizations/${organizationId}/insights/reports`

    return HTTP.get(url, {
      params: query,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    })
  },

  getReportsList(organizationId) {
    const url = `/api/v2/organizations/${organizationId}/insights/report-types`
    return HTTP.get(url)
  },

  getStats(organizationId, reportType = 'top-users', query) {
    const params = {
      params: query,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v2/organizations/${organizationId}/insights/stats/${reportType}`
    return HTTP.get(url, params)
  },

  generateReport(reportOptions) {
    const organizationId = reportOptions.organizationId

    const url = `/api/v2/organizations/${organizationId}/reports`
    return HTTP.post(url, reportOptions)
  },

  getReportXlsxFile(organizationId, reportKey) {
    const url = `/api/v2/organizations/${organizationId}/reports/${reportKey}`

    return HTTP.get(url, {
      responseType: 'arraybuffer',
    })
  },

  getReportsHistory(organizationId) {
    const url = `/api/v2/organizations/${organizationId}/reports`
    return HTTP.get(url)
  },

  deleteReportsHistoryEntry(organizationId, id) {
    const url = `/api/v2/organizations/${organizationId}/reports/${id}`
    return HTTP.delete(url)
  },

  deleteAllExpiredReports(organizationId, payload) {
    const url = `/api/v2/organizations/${organizationId}/reports/bulk`
    return HTTP.post(url, payload)
  },
}
